var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_c('Input', {
    staticStyle: {
      "width": "230px",
      "margin-right": "20px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索销售项目...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchSales
    },
    model: {
      value: _vm.searchSalesText,
      callback: function ($$v) {
        _vm.searchSalesText = $$v;
      },
      expression: "searchSalesText"
    }
  }), _c('Input', {
    staticStyle: {
      "width": "230px",
      "margin-right": "20px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索客户...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchCustomer
    },
    model: {
      value: _vm.searchCusText,
      callback: function ($$v) {
        _vm.searchCusText = $$v;
      },
      expression: "searchCusText"
    }
  })], 1), _c('div', {
    staticClass: "handle-right"
  }, [_c('div', {
    staticClass: "page-wrap"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalCounts) + "条")]), _c('Page', {
    staticStyle: {
      "min-width": "160px"
    },
    attrs: {
      "total": Number(_vm.totalCounts),
      "page-size": _vm.limit,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadSalesOrderTablePage
    }
  })], 1)])]), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "height": _vm.tableHeight,
      "loading": _vm.tableLoading,
      "data": _vm.salesOrderList,
      "border": ""
    }
  })], 1), _c('SODrawer', {
    ref: "SODrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }